import { List } from 'immutable';
import { EventEmitter, OnInit, ElementRef, Component, Output, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/onErrorResumeNext';
import { LogService } from '../log/log.service';
import { LookupStore } from '../lookup/lookup.store';
import { isDefined } from '@ngx-translate/core/src/util';

@Component({
  selector: 'pioneer-inline-search-component',
  templateUrl: 'inline-search.component.html'
})
export class InlineSearchComponent implements OnInit {

  @Output('results')
  results: EventEmitter<List<any>> = new EventEmitter<List<any>>();

  @Output('blur')
  blur: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input('placeholderText')
  public placeholderText: string;

  @Input('lookupStore')
  lookupStore: LookupStore<any, any>;

  @Input('disabled')
  disabled = false;

  nameSearch: String;
  hasResults = false;

  constructor(private el: ElementRef,
              private logService: LogService) {
  }

  ngOnInit(): void {

    const eventStream = Observable.fromEvent(this.el.nativeElement, 'keyup')
      .map(() => this.nameSearch)
      .debounceTime(250)
      .share();

    eventStream.filter((text: string) => isDefined(text) && text.length <= 1)
      .subscribe(_ => {
        this.setResults(List([]));
        this.hasResults = false;
      });

    eventStream.filter((text: string) => isDefined(text) && text.length > 1)
      .map((query: string) => this.search(query).onErrorResumeNext())
      .switch()
      // act on the return of the search
      .subscribe(
        (results: List<any>) => { // on sucesss
          this.logService.info(`InlineSearchBox: results ${JSON.stringify(results)}`);
          this.setResults(results);
          this.hasResults = true;
        },
        (error: any) => { // on error
          this.logService.error(`InlineSearchBox: ${error}`);
        }
      );

    this.lookupStore.selected.subscribe(() => {
      // Clear the search field and result dropdown upon selecting a lookup.
      this.resetSearch();
      this.hasResults = false;
    });

  }

  private setResults(results: any): void {
    this.results.next(results);
  }

  onBlur(): void {
    this.blur.next(true);
    this.resetSearch();
    this.hasResults = false;
  }

  private resetSearch(): void {
    this.nameSearch = '';
    this.setResults(List([]));
  }

  private search(query) {
    return this.lookupStore.search(query)
      .catch((error: any) => {
        this.logService.error(`InlineSearchBox: ${error}`);
        this.setResults([]);
        this.hasResults = false;
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/inline-search/inline-search.component.ts